import type { IdentitySwitchPayload, IdentitySwitchResult, IdentityView } from '~/types/identity'

/** Whether the account orders as a private person or as a company: GET / POST /security/identity. */
export function useIdentity() {
  const api = useApi()

  function fetchIdentity(userId: number): Promise<IdentityView> {
    return api<IdentityView>(`/security/${userId}/identity`)
  }

  function switchIdentity(body: IdentitySwitchPayload): Promise<IdentitySwitchResult> {
    return api<IdentitySwitchResult>('/security/identity', { method: 'POST', body })
  }

  return { fetchIdentity, switchIdentity }
}
